import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
export interface TimeSheetApprovalDetailsVerificationPageState {
    verification: {
        gratificationError: boolean;
    }
}

export interface TimeSheetDetailsWorkTimesError {
      workTimesError: boolean
}

export interface TimeSheetDetailsRegistryKmsError {
  registryKmsError: boolean,
}

export interface TimeSheetDetailsRegistryTimesError {
  registryTimesError: boolean,
}

const initialState: TimeSheetApprovalDetailsVerificationPageState = {
    verification:{
        gratificationError: false,
    }
}

const workTimesErrorState: TimeSheetDetailsWorkTimesError = {
  workTimesError: false
}

const registryKmsErrorState: TimeSheetDetailsRegistryKmsError = {
  registryKmsError: false,
}

const registryTimesErrorState: TimeSheetDetailsRegistryTimesError = {
  registryTimesError: false,
}

export const timesheetApprovalDetailsVerificationSlice = createSlice({
    name: 'timesheetApprovalDetailsVerification',
    initialState,
    reducers: {
      verificationApproval: (state, action: PayloadAction<TimeSheetApprovalDetailsVerificationPageState>) => {
        state.verification.gratificationError = action.payload.verification.gratificationError
      }
    }
});

export const timesheetDetailsWorkTimesErrorSlice = createSlice({
  name: 'timesheetDetailsWorkTimesError',
  initialState: workTimesErrorState,
  reducers: {
    workTimesError: (state, action: PayloadAction<TimeSheetDetailsWorkTimesError>) => {
      state.workTimesError = action.payload.workTimesError
    }
  }
});

export const timesheetDetailsRegistryKmsErrorSlice = createSlice({
  name: 'timesheetDetailsRegistryKmsError',
  initialState: registryKmsErrorState,
  reducers: {
    registryKmsError: (state, action: PayloadAction<TimeSheetDetailsRegistryKmsError>) => {
      state.registryKmsError = action.payload.registryKmsError
    }
  }
});

export const timesheetDetailsRegistryTimesErrorSlice = createSlice({
  name: 'timesheetDetailsRegistryTimesError',
  initialState: registryTimesErrorState,
  reducers: {
    registryTimesError: (state, action: PayloadAction<TimeSheetDetailsRegistryTimesError>) => {
      state.registryTimesError = action.payload.registryTimesError
    }
  }
});

export const { verificationApproval } = timesheetApprovalDetailsVerificationSlice.actions
export const { workTimesError } = timesheetDetailsWorkTimesErrorSlice.actions
export const { registryKmsError } = timesheetDetailsRegistryKmsErrorSlice.actions
export const { registryTimesError } = timesheetDetailsRegistryTimesErrorSlice.actions
